import React from 'react'
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share'

import styles from './shareBar.module.scss'

export default ({ siteUrl }) => {
  // console.log(siteUrl)
  const iconsProps = {
    size: 25,
    round: true,
    borderRadius: 20,
    bgStyle: { fill: '#000000' },
    iconFillColor: '#ffffff',
  }

  return (
    <div className={styles.shareBar}>
      <EmailShareButton url={siteUrl} className={styles.button}>
        <EmailIcon
          size={iconsProps.size}
          round={iconsProps.round}
          borderRadius={iconsProps.borderRadius}
          bgStyle={iconsProps.bgStyle}
          iconFillColor={iconsProps.iconFillColor}
        />
      </EmailShareButton>
      <FacebookShareButton url={siteUrl} className={styles.button}>
        <FacebookIcon
          size={iconsProps.size}
          round={iconsProps.round}
          borderRadius={iconsProps.borderRadius}
          bgStyle={iconsProps.bgStyle}
          iconFillColor={iconsProps.iconFillColor}
        />
      </FacebookShareButton>
      <LinkedinShareButton url={siteUrl} className={styles.button}>
        <LinkedinIcon
          size={iconsProps.size}
          round={iconsProps.round}
          borderRadius={iconsProps.borderRadius}
          bgStyle={iconsProps.bgStyle}
          iconFillColor={iconsProps.iconFillColor}
        />
      </LinkedinShareButton>
      {/* <RedditShareButton url={siteUrl} className={styles.button}>
        <RedditIcon
          size={iconsProps.size}
          round={iconsProps.round}
          borderRadius={iconsProps.borderRadius}
          bgStyle={iconsProps.bgStyle}
          iconFillColor={iconsProps.iconFillColor}
        />
      </RedditShareButton> */}
      <TwitterShareButton url={siteUrl} className={styles.button}>
        <TwitterIcon
          size={iconsProps.size}
          round={iconsProps.round}
          borderRadius={iconsProps.borderRadius}
          bgStyle={iconsProps.bgStyle}
          iconFillColor={iconsProps.iconFillColor}
        />
      </TwitterShareButton>
      <WhatsappShareButton url={siteUrl} className={styles.button}>
        <WhatsappIcon
          size={iconsProps.size}
          round={iconsProps.round}
          borderRadius={iconsProps.borderRadius}
          bgStyle={iconsProps.bgStyle}
          iconFillColor={iconsProps.iconFillColor}
        />
      </WhatsappShareButton>
    </div>
  )
}
